﻿/*!
* jQuery.parseJSON() extension (supports ISO & Asp.net date conversion)
* http://erraticdev.blogspot.com/2010/12/converting-dates-in-json-strings-using.html
* Version 1.0 (13 Jan 2011)
*
* Copyright (c) 2011 Robert Koritnik
* Licensed under the terms of the MIT license
* http://www.opensource.org/licenses/mit-license.php
*/
(function ($) {

    // JSON RegExp
    var dateISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:[.,]\d+)?(?:(?:[+-]\d{2}(?::\d{2})?)|Z|)$/i;
    var dateISOMilliseconds = /[.,](\d+)/i;
    var dateNet = /\/Date\((-?\d+)(?:-\d+)?\)\//i;

    var jsonDateConverter = function (key, value) {
        if (typeof (value) === "string") {
            if (dateISO.test(value)) {
                // Fix for IE
                var ms = value.match(dateISOMilliseconds);
                var fixedValue = value.replace(dateISOMilliseconds, '');
                var result = new Date(fixedValue);
                if (ms !== null) {
                    result.setMilliseconds(parseInt(ms[1].substr(0, 3), 10) || 0);
                }
                return result;
            }
            if (dateNet.test(value)) {
                return new Date(parseInt(dateNet.exec(value)[1], 10));
            }
        }
        return value;
    };

    $.extend({
        parseJSON: function (data, convertDates) {
            /// <summary>Takes a well-formed JSON string and returns the resulting JavaScript object.</summary>
            /// <param name="data" type="String">The JSON string to parse.</param>
            /// <param name="convertDates" optional="true" type="Boolean">Set to true when you want ISO/Asp.net dates to be auto-converted to dates.</param>

            if (typeof data !== "string" || !data) {
                return null;
            }

            convertDates = convertDates === false ? false : true;

            // Make sure leading/trailing whitespace is removed (IE can't handle it)
            data = $.trim(data);

            return window.JSON.parse(data, convertDates === true ? jsonDateConverter : undefined);
        }
    });

    $.ajaxSetup({
        converters: {
            'text json': $.parseJSON
        }
    });
})(jQuery);